import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logEventAction } from '../../actions/usagelogging';
import useMedia from '../WithMediaQueries/useMedia';

const queries = [
  '(min-width: 1281px)',
  '(min-width: 1025px)',
  '(min-width: 768px)',
  '(min-width: 568px)',
  '(min-width: 0px)',
];

// Column counts (relates to above media queries by array index)
const sizes = ['xl', 'lg', 'md', 'sm', 'xs'];

const defaultValue = 'lg';

export default () => {
  const dispatch = useDispatch();
  const previewMode = useSelector((state) => state.previewMode.isEnabled);
  const user = useSelector((state) => state.oidc.user);
  const currentMediaSize = useMedia(queries, sizes, defaultValue);

  const anonymousUser = {
    profile: {
      email: 'Anonymous',
      name: 'Anonymous',
      given_name: 'Anonymous',
      family_name: 'Anonymous',
    },
  };

  const logEvent = (category, action, label, value) => {
    dispatch(
      logEventAction({
        user: user || anonymousUser,
        category: category,
        action: action,
        label: label,
        value: value,
      })
    );
  };

  return {
    useEffect: useEffect,
    dispatch: dispatch,
    useSelector: useSelector,
    previewMode: previewMode,
    user: user,
    userIsAuthenticated: user && user.access_token && !user.expired,
    logEvent: logEvent,
    isSmallScreen:
      currentMediaSize === 'sm' ||
      currentMediaSize === 'xs' ||
      currentMediaSize === 'md',
    mediaSize: currentMediaSize,
  };
};
